<!-- 体验官申请管理后台 -->
<template>
<div class="ambassador-manage" v-loading="loading">
  <!-- 可滚动内容区 -->
  <div class="scroll-content">
  <!-- 统计卡片 -->
  <el-row :gutter="16" class="stat-row">
    <el-col :span="6">
      <div class="stat-card stat-total">
        <h3>全部申请</h3>
        <span class="number">{{ stats.total }}</span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="stat-card stat-pending">
        <h3>待审核</h3>
        <span class="number">{{ stats.pending }}</span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="stat-card stat-approved">
        <h3>已通过</h3>
        <span class="number">{{ stats.approved }}</span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="stat-card stat-rejected">
        <h3>已拒绝</h3>
        <span class="number">{{ stats.rejected }}</span>
      </div>
    </el-col>
  </el-row>
  
  <!-- 筛选栏 -->
  <el-card class="filter-bar">
    <el-row :gutter="12" type="flex" align="middle">
      <el-col :span="4">
        <el-select v-model="filterStatus" placeholder="全部状态" clearable @change="loadList(1)">
          <el-option label="待审核" value="pending"></el-option>
          <el-option label="已通过" value="approved"></el-option>
          <el-option label="已拒绝" value="rejected"></el-option>
          <el-option label="已完成" value="completed"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-input v-model="searchKey" placeholder="搜索姓名/城市" clearable
          @keyup.enter.native="loadList(1)"
          @clear="loadList(1)">
          <el-button slot="append" icon="el-icon-search" @click="loadList(1)"></el-button>
        </el-input>
      </el-col>
    </el-row>
  </el-card>

  <!-- 列表 -->
  <div v-if="list.length === 0 && !loading" class="empty-state">
    <p>暂无申请记录</p>
  </div>

  <div class="application-list">
    <el-card v-for="item in list" :key="item.id" class="app-card" shadow="hover">
      <div class="app-header">
        <div class="applicant-info">
          <h3>{{ item.name }}</h3>
          <p>{{ item.city }} | {{ formatTime(item.createTime) }}</p>
        </div>
        <el-tag :type="statusType(item.status)" effect="plain">
          {{ statusText(item.status) }}
        </el-tag>
      </div>

      <el-row :gutter="16" class="app-body">
        <el-col :span="6">
          <div class="info-item"><label>联系方式</label><span>{{ item.contact || '-' }}</span></div>
        </el-col>
        <el-col :span="6">
          <div class="info-item"><label>尺码</label><span>{{ item.size || '-' }}</span></div>
        </el-col>
        <el-col :span="6">
          <div class="info-item"><label>拍摄地点</label><span>{{ item.shootLocation || '-' }}</span></div>
        </el-col>
        <el-col :span="6">
          <div class="info-item"><label>可拍摄场景</label>
            <div class="scene-tags">
              <el-tag v-for="s in parseScenes(item.scenes)" :key="s" size="mini">{{ s }}</el-tag>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 作品图片缩略图 -->
      <div v-if="item.portfolioImages" class="gallery-thumb">
        <img v-for="(url, idx) in getImageUrls(item.portfolioImages)"
          :key="idx" :src="getImageSrc(url)"
          class="thumb-img" @click="previewBigImage(getImageSrc(url))" />
      </div>

      <div class="app-actions">
        <el-button size="small" type="info" @click="viewDetail(item.id)">查看详情</el-button>
        <template v-if="item.status === 'pending'">
          <el-button size="small" type="success" @click="updateStatus(item.id, 'approved')">通过</el-button>
          <el-button size="small" type="danger" @click="updateStatus(item.id, 'rejected')">拒绝</el-button>
        </template>
        <el-button v-if="item.status === 'approved'" size="small" type="primary" @click="updateStatus(item.id, 'completed')">标记完成</el-button>
        <el-button size="small" type="danger" plain @click="handleDelete(item.id)">删除</el-button>
      </div>
    </el-card>
  </div>
  </div>
  <!-- /可滚动内容区 -->

  <!-- 分页 — 始终固定底部可见 -->
  <el-pagination
    style="text-align:center;margin-top:20px"
    background
    layout="total, sizes, prev, pager, next, jumper"
    :current-page="currentPage"
    :page-size="pageSize"
    :page-sizes="[3, 5, 8, 10]"
    :total="total"
    @current-change="loadList"
    @size-change="handleSizeChange"
  />

  <!-- 详情弹窗 -->
  <el-dialog :visible.sync="detailVisible" title="申请详情" width="800px" top="5vh">
    <el-row :gutter="20" v-if="detail">
      <el-col :span="12">
        <h4>基本信息</h4>
        <div class="info-item"><label>姓名</label><span>{{ detail.name }}</span></div>
        <div class="info-item"><label>联系方式</label><span>{{ detail.contact }}</span></div>
        <div class="info-item"><label>所在城市</label><span>{{ detail.city }}</span></div>
        <div class="info-item"><label>小红书链接</label>
          <span><a :href="detail.redbook" target="_blank" v-if="detail.redbook">{{ detail.redbook }}</a><span v-else>-</span></span>
        </div>
        <div class="info-item"><label>身高/体重</label><span>{{ detail.bodyInfo || '-' }}</span></div>
        <div class="info-item"><label>尺码</label><span>{{ detail.size || '-' }}</span></div>
        <div class="info-item"><label>申请时间</label><span>{{ formatTime(detail.createTime) }}</span></div>
        <div class="info-item"><label>状态</label>
          <el-tag :type="statusType(detail.status)">{{ statusText(detail.status) }}</el-tag>
        </div>
      </el-col>
      <el-col :span="12">
        <h4>拍摄计划</h4>
        <div class="info-item"><label>拍摄地点</label><span>{{ detail.shootLocation || '-' }}</span></div>
        <div class="info-item"><label>拍摄搭子</label><span>{{ detail.partner || '-' }}</span></div>
        <div class="info-item"><label>可拍摄场景</label>
          <div class="scene-tags">
            <el-tag v-for="s in parseScenes(detail.scenes)" :key="s" size="small">{{ s }}</el-tag>
          </div>
        </div>
        <div class="info-item"><label>过往作品</label>
          <span><a :href="detail.portfolio" target="_blank" v-if="detail.portfolio">查看链接</a><span v-else>-</span></span>
        </div>
        <div class="info-item"><label>收件信息</label><span class="pre-wrap">{{ detail.address || '-' }}</span></div>
      </el-col>
    </el-row>

    <!-- 作品图片展示 -->
    <div v-if="detail && detail.portfolioImages" style="margin-top:20px">
      <h4>作品图片</h4>
      <div class="detail-images">
        <img v-for="(url, idx) in getImageUrls(detail.portfolioImages)"
          :key="idx" :src="getImageSrc(url)"
          class="detail-img" @click="previewBigImage(getImageSrc(url))" />
      </div>
    </div>

    <div v-if="detail" style="margin-top:16px;text-align:center">
      <template v-if="detail.status === 'pending'">
        <el-button type="success" @click="updateStatus(detail.id, 'approved');detailVisible=false">通过</el-button>
        <el-button type="danger" @click="updateStatus(detail.id, 'rejected');detailVisible=false">拒绝</el-button>
      </template>
      <el-button v-if="detail.status === 'approved'" type="primary" @click="updateStatus(detail.id, 'completed');detailVisible=false">标记完成</el-button>
    </div>
  </el-dialog>

  <!-- 大图预览 -->
  <el-dialog :visible.sync="previewVisible" width="auto" top="3vh" append-to-body>
    <img :src="previewSrc" style="max-width:90vw;max-height:85vh;display:block" />
  </el-dialog>
</div>
</template>

<script>
import {
  getAmbassadorList,
  getAmbassadorDetail,
  updateAmbassadorStatus,
  deleteAmbassador
} from '@/api/web/ambassador'

export default {
  name: 'AmbassadorManage',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 5,
      filterStatus: '',
      searchKey: '',
      stats: { total: 0, pending: 0, approved: 0, rejected: 0 },
      detailVisible: false,
      detail: null,
      previewVisible: false,
      previewSrc: ''
    }
  },
  mounted() {
    this.loadList(1)
  },
  methods: {
    // 加载列表
    async loadList(page = 1) {
      this.currentPage = page
      this.loading = true
      try {
        const res = await getAmbassadorList({
          page,
          limit: this.pageSize,
          status: this.filterStatus || undefined,
          search: this.searchKey || undefined
        })
        const data = res.data || res
        this.list = data.list || []
        this.total = data.total || 0
        this.calcStats()
      } catch (e) {
        console.error('加载列表失败:', e)
        this.$message.error('加载失败，请检查后端服务')
      }
      this.loading = false
    },

    // 切换每页条数
    handleSizeChange(size) {
      this.pageSize = size
      this.loadList(1)
    },

    // 计算统计数据（从当前列表 + 全量查询）
    async calcStats() {
      try {
        const res = await getAmbassadorList({ page: 1, limit: 1000 })
        const data = res.data || res
        const fullList = data.list || []
        this.stats.total = fullList.length
        this.stats.pending = fullList.filter(a => a.status === 'pending').length
        this.stats.approved = fullList.filter(a => a.status === 'approved').length
        this.stats.rejected = fullList.filter(a => a.status === 'rejected').length
      } catch (e) {
        console.error('统计失败:', e)
      }
    },

    // 查看详情
    async viewDetail(id) {
      try {
        const res = await getAmbassadorDetail(id)
        this.detail = res.data || res
        this.detailVisible = true
      } catch (e) {
        console.error('加载详情失败:', e)
        this.$message.error('加载详情失败')
      }
    },

    // 更新状态
    async updateStatus(id, status) {
      const label = { approved: '通过', rejected: '拒绝', completed: '标记完成' }[status] || status
      try {
        await this.$confirm(`确定要${label}该申请吗？`, '确认', { type: 'warning' })
      } catch { return }

      try {
        await updateAmbassadorStatus(id, status)
        this.$message.success('状态更新成功')
        this.loadList(this.currentPage)
      } catch (e) {
        console.error('更新失败:', e)
        this.$message.error('更新失败，请稍后重试')
      }
    },

    // 删除
    async handleDelete(id) {
      try {
        await this.$confirm('确定要删除该申请吗？此操作不可恢复！', '警告', { type: 'warning' })
      } catch { return }

      try {
        await deleteAmbassador(id)
        this.$message.success('删除成功')
        this.loadList(this.currentPage)
      } catch (e) {
        console.error('删除失败:', e)
        this.$message.error('删除失败，请稍后重试')
      }
    },

    // 图片URL构建
    getImageSrc(url) {
      if (!url) return ''
      // url 格式: "pepcoWeb/pict/xxx.jpg"
      return '/' + url
    },

    // 逗号分隔URL → 数组
    getImageUrls(portfolioImages) {
      if (!portfolioImages) return []
      return portfolioImages.split(',').filter(Boolean)
    },

    // 大图预览
    previewBigImage(src) {
      this.previewSrc = src
      this.previewVisible = true
    },

    // scenes JSON → 数组
    parseScenes(scenes) {
      if (!scenes) return []
      if (Array.isArray(scenes)) return scenes
      try {
        return JSON.parse(scenes)
      } catch {
        return []
      }
    },

    // 状态→Tag类型
    statusType(status) {
      const map = { pending: 'warning', approved: 'success', rejected: 'danger', completed: 'info' }
      return map[status] || 'info'
    },

    // 状态→中文
    statusText(status) {
      const map = { pending: '待审核', approved: '已通过', rejected: '已拒绝', completed: '已完成' }
      return map[status] || status
    },

    // 时间格式化
    formatTime(time) {
      if (!time) return '-'
      const d = new Date(time)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    }
  }
}
</script>

<style scoped>
/* ========== 主容器：flex 纵向布局，占满可用高度 ========== */
.ambassador-manage {
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: calc(100vh - 84px);
  box-sizing: border-box;
}

/* 可滚动内容区 — 占据剩余空间，内部滚动 */
.scroll-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

/* 统计卡片行 */
.stat-row { margin-bottom: 16px; }

/* 统计卡片 */
.stat-card {
  padding: 14px 18px;
  border-radius: 10px;
  color: #fff;
  text-align: center;
}
.stat-total { background: linear-gradient(135deg, #667eea, #764ba2); }
.stat-pending { background: linear-gradient(135deg, #f39c12, #e67e22); }
.stat-approved { background: linear-gradient(135deg, #27ae60, #2ecc71); }
.stat-rejected { background: linear-gradient(135deg, #e74c3c, #c0392b); }
.stat-card h3 { margin: 0 0 5px; font-size: 12px; opacity: 0.9; font-weight: 500; }
.stat-card .number { font-size: 26px; font-weight: bold; }

/* 筛选栏 */
.filter-bar { margin-bottom: 14px; }

/* 应用列表 */
.application-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 单张卡片 — 紧凑化 */
.app-card {
  margin-bottom: 0 !important;
  flex-shrink: 0;
}
.app-card :deep(.el-card__body) {
  padding: 13px 16px !important;
}

.app-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
  flex-wrap: wrap;
  gap: 8px;
}
.applicant-info h3 { margin: 0 0 2px; font-size: 15px; }
.applicant-info p { margin: 0; color: #999; font-size: 11px; }
.app-body { margin-bottom: 6px; }

/* 信息项 */
.info-item {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-bottom: 4px;
}
.info-item label {
  font-size: 11px;
  color: #aaa;
  font-weight: normal;
}
.info-item span {
  font-size: 13px;
  color: #333;
  line-height: 1.3;
}
.info-item .pre-wrap { white-space: pre-wrap; word-break: break-all; }

.scene-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

/* 图片缩略图 */
.gallery-thumb {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
}
.thumb-img {
  width: 46px;
  height: 46px;
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid #eee;
  cursor: pointer;
  transition: transform 0.15s;
  flex-shrink: 0;
}
.thumb-img:hover { transform: scale(1.15); z-index: 1; position: relative; }

/* 操作按钮 */
.app-actions {
  display: flex;
  gap: 6px;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  flex-wrap: wrap;
}

/* 分页栏 — 固定底部，不随列表滚动 */
.ambassador-manage :deep(.el-pagination) {
  flex-shrink: 0;
  padding: 12px 0 4px;
}

/* 详情弹窗图片 */
.detail-images {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.detail-img {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #eee;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #999;
}
.empty-state p { font-size: 15px; }

h4 {
  margin: 0 0 10px;
  padding-bottom: 6px;
  border-bottom: 2px solid #667eea;
  display: inline-block;
  font-size: 15px;
}

/* 滚动条美化 */
.scroll-content::-webkit-scrollbar { width: 5px; }
.scroll-content::-webkit-scrollbar-track { background: transparent; }
.scroll-content::-webkit-scrollbar-thumb { background: #ddd; border-radius: 3px; }
.scroll-content::-webkit-scrollbar-thumb:hover { background: #bbb; }

/* ========== 响应式适配 ========== */

@media (max-width: 1200px) {
  .app-body .el-col { margin-bottom: 4px; }
  .thumb-img { width: 40px; height: 40px; }
  .stat-card .number { font-size: 22px; }
  .stat-card { padding: 12px 14px; }
}

@media (max-width: 992px) {
  .ambassador-manage { padding: 10px; height: calc(100vh - 74px); }
  .scroll-content { padding-right: 3px; }
  .stat-row { margin-bottom: 12px; }
  .filter-bar { margin-bottom: 10px; }
  .app-card :deep(.el-card__body) { padding: 11px 13px !important; }
  .applicant-info h3 { font-size: 14px; }
  .info-item label { font-size: 10px; }
  .info-item span { font-size: 12px; }
  .thumb-img { width: 36px; height: 36px; }
  .gallery-thumb { gap: 4px; }
  .detail-images { grid-template-columns: repeat(3, 1fr); }
  .stat-card { padding: 10px 12px; }
  .stat-card .number { font-size: 20px; }
  .stat-card h3 { font-size: 11px; }
}

@media (max-width: 768px) {
  .ambassador-manage { padding: 8px; height: calc(100vh - 64px); }
  .application-list { gap: 8px; }
  .stat-row { margin-bottom: 10px; }
  .filter-bar { margin-bottom: 8px; }
  .applicant-info h3 { font-size: 13px; }
  .applicant-info p { font-size: 10px; }
  .thumb-img { width: 48px; height: 48px; }
  .app-actions { gap: 4px; justify-content: center; }
  .stat-card { padding: 8px 10px; }
  .stat-card .number { font-size: 18px; }
  .detail-images { grid-template-columns: repeat(2, 1fr); gap: 8px; }
}

@media (max-width: 480px) {
  .ambassador-manage { padding: 6px; height: calc(100vh - 56px); }
  .app-card :deep(.el-card__body) { padding: 9px !important; }
  .applicant-info h3 { font-size: 12px; }
  .thumb-img { width: 42px; height: 42px; }
  .stat-card .number { font-size: 16px; }
}
</style>
